import {Injectable, OnInit} from '@angular/core';
import {Credentials, GraphQLConfig, User} from 'realm-graphql-client';
import {WebSocketLink} from 'apollo-link-ws';
import {getMainDefinition} from 'apollo-utilities';
import {ApiService} from '../Api/api.service';
import {Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {SessionService} from '../Session/session-service.service';
import {IpServiceService} from '../ip-service.service';
import {ApolloClient, concat, HttpLink, InMemoryCache, split} from 'apollo-client-preset';
import gql from 'graphql-tag';
import {environment} from "../../../environments/environment";
import * as Realm from 'realm-web';
import { UrlWithStringQuery } from 'url';
import {FirebaseService} from '../Firebase/firebase.service';
import { CurrencyPipe } from '@angular/common';


const credentials = Credentials.usernamePassword('MobileTwo', 'Mobile_ING%9102');
@Injectable({
  providedIn: 'root'
})
export class RealmService implements OnInit {
  // tslint:disable-next-line:max-line-length
  constructor(private apiService: ApiService, private session: SessionService, private ip: IpServiceService, private Rc: FirebaseService) {
    
  }
  configApp: GraphQLConfig;
  config: GraphQLConfig;
  configWorld: GraphQLConfig;
  client: ApolloClient<any>;
  clientApp: ApolloClient<any>;
  clientWorld: ApolloClient<any>;
  //apiService: ApiService;
  data: Map<string, string>;
  ipAddress: string;
  fcmToken: string;
  env = environment;
  urlMongo = 'https://us-east-1.aws.realm.mongodb.com/api/client/v2.0/app/elementarydb-suzrx/graphql';
  // tslint:disable-next-line:variable-name
  private _response = new Subject();
  response$ = this._response.asObservable();
  // tslint:disable-next-line:variable-name
  private _countries = new Subject();
  countries$ = this._countries.asObservable();
  // tslint:disable-next-line:variable-name
  private _departments = new Subject();
  departments$ = this._departments.asObservable();
  // tslint:disable-next-line:variable-name
  private _towns = new Subject();
  towns$ = this._towns.asObservable();
  // tslint:disable-next-line:variable-name
  private _services = new Subject();
  services$ = this._services.asObservable();
  // tslint:disable-next-line:variable-name
  private _setProviders = new Subject();
  setProviders$ = this._setProviders.asObservable();
  // tslint:disable-next-line:variable-name
  private _countriesArea = new Subject();
  countriesArea$ = this._countriesArea.asObservable();
  // tslint:disable-next-line:variable-name
  private _menus = new Subject();
  menus$ = this._menus.asObservable();
  // tslint:disable-next-line:variable-name
  private _menusHome = new Subject();
  menusHome$ = this._menusHome.asObservable();
  // tslint:disable-next-line:variable-name
  private _searchQuery = new Subject();
  searchQuery$ = this._searchQuery.asObservable();
  // tslint:disable-next-line:variable-name
  private _providersByTypeQuery = new Subject();
  providersByTypeQuery$ = this._providersByTypeQuery.asObservable();
  // tslint:disable-next-line:variable-name
  private _specialtyListQuery = new Subject();
  specialtyListQuery$ = this._specialtyListQuery.asObservable();
  // tslint:disable-next-line:variable-name
  private _allInfoProvider = new Subject();
  allInfoProvider$ = this._allInfoProvider.asObservable();
  // tslint:disable-next-line:variable-name
  private _contactListQuery = new Subject();
  contactListQuery$ = this._contactListQuery.asObservable();
  // tslint:disable-next-line:variable-name
  private _scheduleListQuery = new Subject();
  scheduleListQuery$ = this._scheduleListQuery.asObservable();
  // tslint:disable-next-line:variable-name
  private _digitalCardUrl = new Subject();
  digitalCardUrl$ = this._digitalCardUrl.asObservable();
  // tslint:disable-next-line:variable-name
  private _quequeProvider = new Subject();
  quequeProvider$ = this._quequeProvider.asObservable();
  // tslint:disable-next-line:variable-name
  private _isLogin = new Subject();
  isLogin$ = this._isLogin.asObservable();
  // tslint:disable-next-line:variable-name
  private _currentScreen = new Subject();
  currentScreen$ = this._currentScreen.asObservable();
  // tslint:disable-next-line:variable-name
  private _locationProvider = new Subject();
  locationProvider$ = this._locationProvider.asObservable();
  // tslint:disable-next-line:variable-name
  private _providersInfo = new Subject();
  providersInfo$ = this._providersInfo.asObservable();
  private _importantPhones = new Subject();
  importantPhones$ = this._importantPhones.asObservable();
  private _emergencyPhones = new Subject();
  emergencyPhones$ = this._emergencyPhones.asObservable();
  contries: any;
  special = [];
  // tslint:disable-next-line:contextual-lifecycle
  ngOnInit(): void { }
  async logMongo(): Promise<string> {
    const app = new Realm.App({ id: 'elementarydb-suzrx' });
    // Create an anonymous credential
    const credentials = Realm.Credentials.apiKey('IP0isJaBqOedEdCCIrDcTzgyC4AZ5nn2lqanxFYRsvV57HXQYQTiBdZd5JD02GRy');
    try {
      // Authenticate the user
      const user: Realm.User = await app.logIn(credentials);
      // `App.currentUser` updates to match the logged in user
      // assert(user.id === app.currentUser.id);
      return user.accessToken;
    } catch (err) {
      console.error('Failed to log in', err);
    }
  }
  async loginAsync() {
    /*
    const user = await User.authenticate(credentials, 'https://provider-sync-cloud-staging.de1a.cloud.realm.io/');
    this.config = await GraphQLConfig.create(user, '/StagingSync-Provider');
    const httpLink = concat(
      this.config.authLink,
      // Note: if using node.js, you'll need to provide fetch as well.
      new HttpLink({ uri: this.config.httpEndpoint })
    );
    const linksocket = new WebSocketLink({uri: this.config.webSocketEndpoint, options: {
        connectionParams: this.config.connectionParams, reconnect: true
      }});
    const link = split(
        // split based on operation type
        ({ query }) => {
          const definition = getMainDefinition(query);
          return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
        },
        linksocket,
        httpLink
      );
    this.client = new ApolloClient({
        link,
        cache: new InMemoryCache()
      });
      */
  }
  async loginAsyncApp() {
    /*
    const user = await User.authenticate(credentials, 'https://provider-sync-cloud-staging.de1a.cloud.realm.io/');
    this.configApp = await GraphQLConfig.create(user, '/RPN');
    const httpLink = concat(
      this.configApp.authLink,
      // Note: if using node.js, you'll need to provide fetch as well.
      new HttpLink({ uri: this.configApp.httpEndpoint })
    );
    const linksocket = new WebSocketLink({uri: this.configApp.webSocketEndpoint, options: {
        connectionParams: this.configApp.connectionParams, reconnect: true
      }});
    const link = split(
      // split based on operation type
      ({ query }) => {
        const definition = getMainDefinition(query);
        return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
      },
      linksocket,
      httpLink
    );
    this.clientApp = new ApolloClient({
      link,
      cache: new InMemoryCache()
      });
      */
  }
  async loginAsyncWorld() {
    const user = await User.authenticate(credentials, 'https://provider-sync-cloud-staging.de1a.cloud.realm.io/');
    this.configWorld = await GraphQLConfig.create(user, '/world');
    const httpLink = concat(
      this.configWorld.authLink,
      // Note: if using node.js, you'll need to provide fetch as well.
      new HttpLink({ uri: this.configWorld.httpEndpoint })
    );
    const httpLinks = this.configWorld.webSocketEndpoint;
    const linksocket = new WebSocketLink({uri: this.configWorld.webSocketEndpoint, options: {
        connectionParams: this.configWorld.connectionParams, reconnect: true
      }});
    const link = split(
      // split based on operation typepaises
      ({ query }) => {
        const definition = getMainDefinition(query);
        return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
      },
      linksocket,
      httpLink,
    );
    this.clientWorld = new ApolloClient({
      link,
      cache: new InMemoryCache()
    });
  }

  async getCountries() {  
    return new Promise((resolve, reject) => {
      let data = {
        data: {
          countryAppSettingsOrms: [
            {
              code: 502,
              descriptionCountry: "502 - Guatemala",
              idCountry: 1,
              state: 1,
              __typename: "CountryAppSettingsOrm"
            },
            {
              code: 503,
              descriptionCountry: "503 - El Salvador",
              idCountry: 2,
              state: 1,
              __typename: "CountryAppSettingsOrm"
            },
            {
              code: 504,
              descriptionCountry: "504 - Honduras",
              idCountry: 3,
              state: 1,
              __typename: "CountryAppSettingsOrm"
            },
            {
              code: 506,
              descriptionCountry: "506 - Costa Rica",
              idCountry: 4,
              state: 1,
              __typename: "CountryAppSettingsOrm"
            }
          ],
          loading: false,
          networkStatus: 7,
          stale: false
        }
      };
      console.log('paises::::' + JSON.stringify(data));
      this._countries.next(data);
      resolve(data);
    });
  }

  getCountriesWorld() {
    /*
    this.clientWorld.query({
      query: gql`
      query{
      countries(query:""){
        id
        iso
        name
        codigo
      }
    }
    `
    }).then(data => {
      this._countries.next(data.data.countries);
      console.log('paises::::' + JSON.stringify(data.data.countries));
    }).catch( err => {
      console.log( err);
    });*/
  }
  getDepartmentsWorld(countryId: number) {
    const q = 'idCountry.id ==\'' + countryId + '\'';
    const gt = [
      'Huehuetenango',
      'Guatemala City',
      'Vista Hermosa',
      'El Salvador',
      'Catarina',
      'Amatitlán',
      'Mixco',
      'Melchor de Mencos',
      'Chimaltenango',
      'San Pedro Sacatepequez',
      'Antigua Guatemala',
      'Santa Catarina Pinula',
      'Quetzaltenango',
      'Quesada',
      'Santa Cruz Naranjo',
      'Villa Nueva',
      'Zacapa',
      'Ciudad Vieja',
      'Petapa',
      'San Antonio Miramar',
      'Palin',
      'La Reforma',
      'Coban',
      'Mazatenango',
      'Santa Lucia Cotzumalguapa',
      'Retalhuleu',
      'Escuintla',
      'San Marcos',
      'La Reforma',
      'San Juan',
      'Panajachel',
      'Jocotenango',
      'Santa Cruz La Laguna',
      'Esquipulas',
      'Solola',
      'TotonicapÃ¡n',
      'Chiquimula',
      'Puerto Barrios',
      'Central',
      'Flores',
      'Santa Rosa',
      'San Jose Pinula',
      'El Naranjo',
      'El Limon',
      'Cambote'
    ];
    const sv = [
      'San Salvador',
      'San Miguel',
      'La Libertad',
      'Ilopango',
      'Antiguo Cuscatlan',
      'Soyapango',
      'Santa Tecla',
      'Botoncillal El Botoncillo',
      'Mejicanos',
      'Nuevo Cuscatlan',
      'San Jose Villanueva',
      'Zaragoza',
      'Santa Ana',
      'Gigante',
      'Colonia Escalon',
      'Santiago Texacuangos',
      'Ayutuxtepeque',
      'Apopa',
      'Coatepeque',
      'San Marcos',
      'Usulutan',
      'Ozatlan',
      'Delgado',
      'Guazapa',
      'Apaneca',
      'Ahuachapan',
      'Sonsonate',
      'Lourdes',
      'Colon',
      'Cuscatancingo'
    ];

    const gtsortWithWord = gt.sort( (a, b) => {
      return a.localeCompare(b);
    });
    const svsortWithWord = sv.sort( (a, b) => {
      return a.localeCompare(b);
    });
    switch (countryId) {
      case 502: {
        const q = [];
        gtsortWithWord.forEach(val => {
            q.push({dept: val});
            });
        this._departments.next(q);
        break;
      }
      case 503: {
        // tslint:disable-next-line:no-shadowed-variable
        const q = [];
        svsortWithWord.forEach(val => {
          q.push({dept: val});
        });
        this._departments.next(q);
        break;
      }
    }
  }
  getTownsWorld(departmentId: number) {
    
  }

  getServicesOrm() {
    /*
    this.client.query({
      query: gql`
       query {
          serviceOrms(query:"strDescription != null"){
            code
            strDescription
          }
        }
      `
    }).then(data => {
      this._services.next(data.data.serviceOrms);
      console.log('serviceOrms:::', JSON.stringify(data.data.serviceOrms));
    }, error => {
      console.log('serviceOrms:::', error);
    });
    */
  }

  getCountriesArea() {

    return new Promise((resolve, reject) => {
      let data = {
        data: {
          countryCodeAppSettingsOrms: [
            {
              idCode: "Seleccione",
              nameCountry: "Seleccione país",
              __typename: "CountryCodeAppSettingsOrm"
            },
            {
              idCode: "+502",
              nameCountry: "502 - Guatemala",
              __typename: "CountryCodeAppSettingsOrm"
            },
            {
              idCode: "+503",
              nameCountry: "503 - El Salvador",
              __typename: "CountryCodeAppSettingsOrm"
            },
            {
              idCode: "+504",
              nameCountry: "504 - Honduras",
              __typename: "CountryCodeAppSettingsOrm"
            },
            {
              idCode: "+506",
              nameCountry: "506 - Costa Rica",
              __typename: "CountryCodeAppSettingsOrm"
            }
          ],
          loading: false,
          networkStatus: 7,
          stale: false
        }
      };
      console.log('areas::::' + JSON.stringify(data));
      this._countriesArea.next(data);
      resolve(data);
    });
  }

  getMenu() {
    /*
    this.clientApp.query({
      query: gql`
       query{
        optionsMenus(sortBy:"order") {
          titleRc
          storyboardId
        }
      }
      `
    }).then(data => {
      this._menus.next(data);
      console.log("menu::::: ", data);
    });
    */
  }
  getMenuHome() {
    
    return new Promise((resolve, reject) => {
      this.Rc.fetchActivate().then(() => {
        let data = {
          data: {
            webSideMenus: [
              {
                Title: this.Rc.getStringRC('menu_option_home_title'),
                icon: "pi-home",
                storyboardId: "content",
                subTitleRc: "",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('global_benefit_title'),
                icon: "pi-star",
                storyboardId: "benefits",
                subTitleRc: "global_sub_title_one",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('global_title_menu_two'),
                icon: "pi-check",
                storyboardId: "authorization",
                subTitleRc: "global_sub_title_two",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('new_auth'),
                icon: "pi-file-o",
                storyboardId: "new-authorization",
                subTitleRc: "",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('menu_option_profile_title'),
                icon: "pi-user",
                storyboardId: "profile",
                subTitleRc: "",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('menu_option_contact_title'),
                icon: "pi-envelope",
                storyboardId: "contact",
                subTitleRc: "",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('menu_option_provider'),
                icon: "pi-heart",
                storyboardId: "providers",
                subTitleRc: "global_sub_title_three",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('global_title_renovation'),
                icon: "pi-sort-alt",
                storyboardId: "renovation",
                subTitleRc: "global_sub_title_five",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('menu_option_emergency_title'),
                icon: "pi-exclamation-triangle",
                storyboardId: "emergency",
                subTitleRc: "",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('global_setting_title'),
                icon: "pi-cog",
                storyboardId: "settings",
                subTitleRc: "",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('global_digital_reclaim'),
                icon: "pi-file-o",
                storyboardId: "https://reclamodigital.tecniseguros.com/reclamo-digital",
                subTitleRc: "",
                __typename: "WebSideMenu"
              },
              {
                Title: 'Reclamos',
                icon: "pi-check",
                storyboardId: "claims",
                subTitleRc: "",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('global_forms_title'),
                icon: "pi-download",
                storyboardId: "forms",
                subTitleRc: "descargue formularios.",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('global_imp_phones'),
                icon: "pi-mobile",
                storyboardId: "important-phones",
                subTitleRc: "telefonos importantes",
                __typename: "WebSideMenu"
              },/*
              {
                Title: "Asistencia dental",
                icon: "pi-bookmark",
                storyboardId: "dental-assistance",
                subTitleRc: "asistencia dental.",
                __typename: "WebSideMenu"
              },*/
              {
                Title: this.Rc.getStringRC('global_glossary_title'),
                icon: "pi-list",
                storyboardId: "glossary",
                subTitleRc: "asistencia dental.",
                __typename: "WebSideMenu"
              },
              {
                Title: this.Rc.getStringRC('close'),
                icon: "pi-times-circle",
                storyboardId: "close",
                subTitleRc: "",
                __typename: "WebSideMenu"
              }
            ]
          },
          loading: false,
          networkStatus: 7,
          stale: false
        };
        console.log("menuHome::::: ", data);
        this._menusHome.next(data.data.webSideMenus);
        resolve(data.data.webSideMenus);
       });
    });
  }

  // @ts-ignore
  async getLoginSettings(card: string, dob: string, cCode: string) {
    console.log( card + '   ' + dob + '   ' + cCode);
    this.getIP();
    let browser:any = this.getBrowserVersion();
    const path = 'v1/insuredLogin';
    const url = this.env.urlEnvironment+'/insured-access-web/api';
    const params = new HttpParams()
          .set('policyCardNumber', card)
          .set('policyCountryCode', cCode)
          .set('birthDate', dob)
          .set('portalAllowed', 'RPN')
          .set('language', 'es')
          .set('modelDevice', browser.name)
          .set('versionSO', browser.name)
          .set('versionAPP', '1.0')
          // @ts-ignore
          .set('uuid', await this.session.getParam('ip'))
          // @ts-ignore
          .set('tokenFcm', 'prueba');
    console.log('params ', params);
    this.apiService.getMethod(url, path, [], params);
  }

  async getRegisterSettings(cCode: string, phone: string, email: string, dpi: string, type: string) {
    console.log( cCode + '   ' + phone + '   ' + email);
      const ipAd = '';
      const map = [];
      const da = [];
      const card = await this.session.getvvalueSession('data', 'completeCard');
      const ccode = await this.session.getvvalueSession('data', 'countryCode');
      const bdate = await this.session.getvvalueSession('data', 'dateBirth');
      const path = 'v1/insuredRegistered';
      const url = this.env.urlEnvironment+'/insured-access-web/api';

      const params: any = {};
      let browser:any = this.getBrowserVersion();  

      params['policyCardNumber'] = card;
      params['policyCountryCode'] = ccode;
      params['birthDate'] = bdate;
      params['documentId'] = dpi;
      params['email'] = email;
      params['phoneNumber'] = cCode + phone;
      params['versionSO'] = browser.name;
      params['versionAPP'] = '1.0';
      //params[map[12]] = await this.session.getvvalueSession('data', 'fcmToken');
      params['tokenFcm'] = 'prueba';
      params['modelDevice'] = browser.name;
      params['uuid'] = await this.session.getvvalueSession('data', 'ip');
      params['language'] = 'es';
      params['portalAllowed'] = 'RPN';

      console.log( params);
      
      if (type === 'POST') {
        console.log('llamada post');
        this.apiService.postMethodRegister(url, path, [], params);
      } else {
        console.log('llamada put');
        return this.apiService.putMethodInsuredRegister(url, path, [], params);
      }
  }

  async forgotIdPost(documentId: number, email: string, phoneNumber: string, portalAllowed: string, birthdate: string, completeName: string) {
    //console.log( cCode + '   ' + phone + '   ' + email);
      
      const path = 'v1/sendForgotId';
      const url = this.env.urlEnvironment+'/insured-access-web/api';

      const params: any = {};

      params['documentId'] = documentId;
      params['email'] = email;
      params['phoneNumber'] = phoneNumber;
      params['portalAllowed'] = portalAllowed;
      params['birthdate'] = birthdate;
      params['completeName'] = completeName;

      console.log( params);
      return  this.apiService.postMethodForgotId(url, path, [], params);
  }

  async forgotIdPostTS(country: number, firstName: string, lastName: string, birthdate: string, cui: string, email: string, phoneNumber: string) {
    //console.log( cCode + '   ' + phone + '   ' + email);
    

      const params: any = {};

      params['pais'] = country;
      params['primerNombre'] = firstName;
      params['primerApellido'] = lastName;
      params['fechaNacimiento'] = birthdate;
      params['dpi'] = cui;
      params['email'] = email;
      params['telefono'] = phoneNumber;

      //console.log( params);
      return  this.apiService.postMethodTS(params);
  }

  async cannotLoginPost(documentId: number, email: string, phoneNumber: string, portalAllowed: string, birthdate: string, completeName: string, policyCardNumber: UrlWithStringQuery, blob: any[]) {
    //console.log( cCode + '   ' + phone + '   ' + email);
      
      const path = 'v1/sendUpdateInsured';
      const url = this.env.urlEnvironment+'/insured-access-web/api';

      const params: any = {};

      params['documentId'] = documentId;
      params['email'] = email;
      params['phoneNumber'] = phoneNumber;
      params['portalAllowed'] = portalAllowed;
      params['birthdate'] = birthdate;
      params['completeName'] = completeName;
      params['policyCardNumber'] = policyCardNumber;
      params['blob'] = blob;

      console.log( params);
      return  this.apiService.postMethodCannotLogin(url, path, [], params);
  }

  async postSessionSettings() {
    //console.log( cCode + '   ' + phone + '   ' + email);
      
      const path = 'v1/insuredSessionLog';
      const url = this.env.urlEnvironment+'/insured-access-web/api';
      let browser:any = this.getBrowserVersion();
      const card = await this.session.getvvalueSession('data', 'completeCard');
      const ccode = await this.session.getvvalueSession('data', 'countryCode');

      const params: any = {};
      console.log("card: "+ card);
      console.log("code: "+ ccode);

      params['policyCardNumber'] = card;
      params['policyCountryCode'] = ccode;
      params['typeSession'] = 4;
      params['portalAllowed'] = 'RPN';
      params['versionSO'] = browser.name;
      params['versionAPP'] = '1.0';
      params['language'] = 'es';
      params['uuid'] = await this.session.getvvalueSession('data', 'ip');

      console.log( params);
      return  this.apiService.postMethodCannotLogin(url, path, [], params);
  }

  async getSessionSettings() {
    const card = await this.session.getvvalueSession('data', 'completeCard');
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    const path = 'v1/insuredSessionLog';
    const url = this.env.urlEnvironment+'/insured-access-web/api';
    const params = new HttpParams()
          .set('policyCardNumber', card)
          .set('policyCountryCode', ccode)
          .set('language', 'es');
    console.log('params ', params);
    await this.apiService.getMethodSession(url, path, [], params);
  }

  async getCouponRenovationSettings() {
      const map = [];
      const da = [];
      //const card = '502-567199'; 
      const card =  await this.session.getvvalueSession('data', 'completeCard');
      const ccode = await this.session.getvvalueSession('data', 'countryCode');
      const params = new HttpParams()
        .set('policyCardNumber', card )
        .set('countryCode', ccode)
        .set('portalAllow', 'RPN');
      await this.apiService.getCouponRenovationMethod(this.env.urlEnvironment+'/insured-access-web/api', 'v1/findInsuredCoupon', [], params);
  }

  async getOtpSettings(code: string, typeValidate: string, typeRequest: string) {
    console.log( code);
    const map = [];
    const da = [];
    let browser:any = this.getBrowserVersion();
    const card = await this.session.getvvalueSession('data', 'completeCard');
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
   let path = "v1/insuredOtp"
    let url = this.env.urlEnvironment+"/insured-access-web/api";
    const params = new HttpParams()
          .set("policyCardNumber", card)
          .set("policyCountryCode", ccode)
          .set("token", code)
          .set("typeValidate", typeValidate)
          .set("typeRequest", typeRequest)
          .set("modelDevice", browser.name)
          .set("portalAllowed", 'RPN')
          .set("uuid", await this.session.getvvalueSession('data', 'ip'))
          .set("tokenFcm", "prueba")
          .set("language", 'es')
          .set("versionSO", browser.name)
          .set("versionAPP", '1.0');
      console.log("params ",params);
      this.apiService.getMethodOtp(url, path, [], params);
  }

  async putInsuredRegistered(code: string, typeValidate: string, typeRequest: string) {
    console.log( code);
    const map = [];
    const da = [];
    const card = await this.session.getvvalueSession('data', 'completeCard');
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    let browser:any = this.getBrowserVersion();
   let path = "v1/insuredRegistered"
    let url = this.env.urlEnvironment+"/insured-access-web/api";
    const params = new HttpParams()
          .set("policyCardNumber", card)
          .set("policyCountryCode", ccode)
          .set("token", code)
          .set("typeValidate", typeValidate)
          .set("typeRequest", typeRequest)
          .set("modelDevice", browser.name)
          .set("portalAllowed", 'RPN')
          .set("uuid", await this.session.getvvalueSession('data', 'ip'))
          .set("tokenFcm", "prueba")
          .set("language", 'es')
          .set("versionSO", browser.name)
          .set("versionAPP", '1.0');
      console.log("params ",params);
      this.apiService.getMethodOtp(url, path, [], params);
  }


  async getBenefitSettings() {
    const map = [];
    const da = [];
    const card = await this.session.getvvalueSession('data', 'cardNumber');
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    let path = "v1/policyHolderBenefits"
    let url = this.env.urlEnvironment+"/insured-access-web/api";
    const params = new HttpParams()
        .set("policyCardNumber", card)
        .set("policyCountryCode", ccode)
        .set("policy", await  this.session.getvvalueSession('user', 'policy'))
        .set("language", 'es')
        .set("portalAllowed", 'RPN')
        .set("companyName", await this.session.getvvalueSession('user', 'companyName'));
    //console.log("params ",params);
    this.apiService.getMethodBenefit(url, path, [], params);
  }

  async getAuthorizationSetting(dtt1: string, dtt2: string) {
    console.log("getAuthorization: "+ dtt1 + " "+ dtt2);
    const d = require('@js-joda/core').LocalDate;

    const dateNow = Date.now();
    const hoy = new Date(dateNow);
    let todayDateFormat= hoy.toLocaleDateString('en-GB');

    let msSixMonth = 183*1000*60*60*24*2;
    const msToday = new Date(dateNow).getTime();
    let firstRangeDefaultMs = msToday - msSixMonth;
    const sixMonthBack = new Date(firstRangeDefaultMs);
    let firstRangeFilterDefault = sixMonthBack.toLocaleDateString('en-GB');

    const map = [];
    const card = await this.session.getvvalueSession('data', 'cardNumber');
    const ccode = await this.session.getvvalueSession('data', 'countryCode');

    let dt1 = firstRangeFilterDefault;
    let dt2 = todayDateFormat;
    if (dtt1 !== '' && dtt2 !== '') {
      dt1 = dtt1;
      dt2 = dtt2;
    }

    let path = "v1/policyHolderAuthorizationsByDates"
    let url = this.env.urlEnvironment+"/insured-access-web/api";

    const params = new HttpParams()
        .set('policyCardNumber', card )
        .set('policyCountryCode', ccode)
        .set('toDate', dt1)
        .set('endDate', dt2)
        .set('language', 'es')
        .set('portalAllowed', 'RPN')
        .set('policy', await  this.session.getvvalueSession('user', 'policy'))
        .set('companyName', await this.session.getvvalueSession('user', 'companyName'));
      this.apiService.getAuthorization(url, path, [], params);
      console.log( map);
  }

  async getClaimSetting(dtt1: string, dtt2: string) {
    console.log("getClaims: "+ dtt1 + " "+ dtt2);
    const d = require('@js-joda/core').LocalDate;

    const dateNow = Date.now();
    const hoy = new Date(dateNow);
    let todayDateFormat= hoy.toLocaleDateString('en-GB');

    let msSixMonth = 183*1000*60*60*24*2;
    const msToday = new Date(dateNow).getTime();
    let firstRangeDefaultMs = msToday - msSixMonth;
    const sixMonthBack = new Date(firstRangeDefaultMs);
    let firstRangeFilterDefault = sixMonthBack.toLocaleDateString('en-GB');

    const map = [];
    const card = await this.session.getvvalueSession('data', 'completeCard');
    const ccode = await this.session.getvvalueSession('data', 'countryCode');

    let dt1 = firstRangeFilterDefault;
    let dt2 = todayDateFormat;
    if (dtt1 !== '' && dtt2 !== '') {
      dt1 = dtt1;
      dt2 = dtt2;
    }

    let path = "v1/policyHolderReimbursementByDates"
    let url = this.env.urlEnvironment+"/insured-access-web/api";

    const params = new HttpParams()
        .set('policyCardNumber', card )
        .set('policyCountryCode', ccode)
        .set('toDate', dt1)
        .set('endDate', dt2)
        .set('portalAllowed', 'RPN')
      this.apiService.getClaim(url, path, [], params);
      console.log( map);
  }

  async getCouponSettings() {
    const card = await this.session.getvvalueSession('data', 'cardNumber');
    const ccode = await this.session.getvvalueSession('data', 'countryCode');

    let path = "v1/insuredCouponsInformation"
    let url = this.env.urlEnvironment+"/insured-access-web/api";

    const params = new HttpParams()
      .set('policyCardNumber', card.replace(ccode,'') )
      .set('policyCountryCode', ccode)
      .set('language', 'es')
      .set('portalAllowed', 'RPN');
    this.apiService.getMethodProfile(url, path, [], params);
    console.log( params);
  }

  async getDigitalCard(card: string) {
    let backurl = '';
    let fronturl = '';
    let w = {
      front: '',
      back: '',
    };

    const map = [];
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    const dependents = JSON.parse(await this.session.getParam('dependents'));

    let path = "v1/digitalPolicyCardNumber"
    let url = this.env.urlEnvironment+"/insured-access-web";
    return new Promise((resolve, reject) => {
      const paramshttp = new HttpParams()
          .set('policyCardNumber', card )
          .set('policyCountryCode', ccode)
          .set('type', 'F')
          .set('portalAllowed', 'RPN');

      console.log( paramshttp);
      let str = '';
      fronturl = url + '/' + path + '?' + paramshttp;
      console.log('urlFront', url + '/' + path + '?' + paramshttp);

      if ( Object.keys(dependents).length > 1) {
        // tslint:disable-next-line:forin
        for (const dependentsKey in dependents) {
          str += dependents[dependentsKey].policyHolderCompleteCardNumber + ' ' + dependents[dependentsKey].policyHolderCompleteName+ '\n';
        }
        const paramshttp2 = new HttpParams()
          .set('policyCardNumber', card )
          .set('policyCountryCode', ccode)
          .set('type', 'B')
          .set('portalAllowed', 'RPN')
          .set('dependentSet', str);
        w = {
          front: url + '/' + path + '?' + paramshttp,
          back: url + '/' + path + '?' + paramshttp2,
        };
        backurl = url + '/' + path + '?' + paramshttp2;
        this._digitalCardUrl.next(w);
        resolve(w);
        console.log('urlBack', url + '/' + path + '?' + paramshttp2);
      } else {
        const paramshttp2 = new HttpParams()
          .set('policyCardNumber', card )
          .set('policyCountryCode', ccode)
          .set('type', 'B')
          .set('portalAllowed', 'RPN');
        w = {
          front: url + '/' + path + '?' + paramshttp,
          back: url + '/' + path + '?' + paramshttp2,
        };
        backurl = url + '/' + path + '?' + paramshttp2;
        this._digitalCardUrl.next(w);
        resolve(w);
        console.log('urlBack', url + '/' + path + '?' + paramshttp2);
      }
    });
  }

  async getRenovationSettings() {
    const card = await this.session.getvvalueSession('data', 'completeCard');
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    let path = "v1/validateInsuredRenewed"
    let url = this.env.urlEnvironment+"/insured-access-web/api";
    const params = new HttpParams()
          .set("policyCardNumber", card)
          .set("countryCode", ccode)
          .set("portalAllow", 'RPN');
      console.log("params ",params);
      this.apiService.getMethodRenovation(url, path, [], params);
  }

  async getValidCoupon() {
    /*
    const card = await this.session.getvvalueSession('data', 'cardNumber');
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    this.client.query({
      // tslint:disable-next-line:max-line-length
      // tslint:disable-next-line:max-line-length                                                   2                                   3                             12                           4
      query: gql`query{settingOrms(query:"key=='base_url_api' || key=='method_findInsuredCoupon' || key=='param_policyCardNumber' || key=='param_countryCode' || key=='param_portalAllowed' "){value}}`
    }).then(async value => {
      const d = value.data.settingOrms;
      const map = [];
      const da = [];
      d.forEach(val => {
        map.push(val.value);
      });
      const params = new HttpParams()
        .set(map[1], '502-605360')
        .set(map[4], ccode)
        .set('portalAllow', 'RPN');
      // console.log('renovationParams', params);
      this.apiService.getInsuredCoupons(map[0], map[3], [], params);
    });*/
  }

  

  async getContactProvider(idLocation: string) {
    /*
    const q = 'idLocation.idLocation ==\'' + idLocation + '\'';
    const qryProv = gql`
       query contact($val:String){
        contactOrms(query:$val){
          idTypeContact{
              strDescription
              idContactType
            }
          strDescription
          idLocation{
            idLocation
          }
        }
      }
      `;
    this.client.watchQuery({
      query: qryProv,
      variables: {val: q}
    }).subscribe((resultprov: any) => {
      this._contactListQuery.next(resultprov.data.contactOrms);
      const qs = resultprov.data.contactOrms[0].idLocation.idLocation;
      console.log('idLocation', qs);
    });*/
  }

  getScheduleProvider(idLocation: string) {
    /*
    const q = 'idLocation.idLocation ==\'' + idLocation + '\'';
    const qryProv = gql`
       query schedule($val:String){
        scheduleOrms(query:$val){
          strDescription
          idLocation{
            idLocation
          }
        }
      }
      `;
    this.client.watchQuery({
      query: qryProv,
      variables: {val: q}
    }).subscribe((resultprov: any) => {
      console.log('schedule provider', resultprov.data.scheduleOrms);
      this._scheduleListQuery.next(resultprov.data.scheduleOrms);
    });
    */
  }

  async getCopaymentbyProvider(idProvider: string) {
    const card = await this.session.getvvalueSession('data', 'cardNumber');
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    const qs = idProvider.split('-');
    console.log( idProvider);
    console.log( qs);
    let path = "v1/insuredParticipation"
    let url = this.env.urlEnvironment+"/insured-access-web/api";
    const params = new HttpParams()
        .set('policyCardNumber', card )
        .set('policyCountryCode', ccode)
        .set('providerCountryCode', qs[0])
        .set('providerType', qs[1])
        .set('providerCode', qs[2]);
    this.apiService.getMethodGeneral(url, path, [], params);
    console.log( params);
  }

  async getSetProviders() {
    const setProviders = JSON.parse(await this.session.getParam('setOfProviders'));
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    let q = '';
    const q2 = [];
    for (const providersKey in setProviders) {
      // @ts-ignore
       q2.push(setProviders[providersKey].code);
       if (providersKey.toString() === '0') {
        q += '"' + setProviders[providersKey].code + '"' ;
      } else {
        q += ',"' + setProviders[providersKey].code + '"' ;
      }
      /*if (providersKey.toString() === "0") {
        q += "code== \"" + setProviders[providersKey].code + "\"" ;
      } else {
        q += "|| code== \"" + setProviders[providersKey].code + "\"" ;
      }*/
    }
    const querys = {
      query: 'query($id:[String]){setProviderOrms(query:{code_in:$id}){provider {_id code name specialty { alias code strDescription} SubSpecialty {alias code strDescription} offline priority telemedicine}}}',
      variables: {
        id: q2
      }
    };
    let art = [];
    //const providers = JSON.parse(await this.session.getParam('providers'));
    //console.log('provider', providers);
    //this._setProviders.next(providers);
    this.apiService.postMethodMongo(querys).then((res: any) => {
      art = [];
      res.data.setProviderOrms.forEach( (it: any) => {
        it.provider.forEach( it2 => {
          if (!art.find(tt => tt.code === it2.code)) {
            art.push(it2);
          }
        });
      });
      this.session.saveParam('providers', JSON.stringify(art));
      return this._setProviders.next(art);
    }).catch(erro => {
      console.log('res mongo', erro);
      return this._setProviders.next(erro);
    });
   /* }).catch(erro => {
      console.log('res mongo', erro);
    });*/
  }
  // tslint:disable-next-line:max-line-length
 /* async findProvidersIntelligent(country: string, typeProvider: string, department?: string, city?: string, specialty?: string, name?: string ) {
    const providers = JSON.parse(await this.session.getParam('providers'));
    const filterProviders = providers.filter((p) => JSON.stringify(p.code).toString().indexOf((country + '-' + typeProvider + '-')) > -1 );
  }*/

  // tslint:disable-next-line:max-line-length
  async getProvidersByTypeOld(country: string, type: any[], CAMPI?: boolean, department?: string, city?: string, specialty?: string, name?: string) {
    let q = '';
    let sq = country + '-';
    console.log("typeToSearch: ", type);
    
    let providers: any[] = [];
    let filterResults: any [] = [];
    JSON.parse(<string>this.session.getParam('providers')).map((it:any) => {
      type.map ((ty:any) => {
        sq = country + '-' + ty + '-';
        if (it.code.toString().includes(sq)) {
          filterResults.push(it);
        }
      })
      providers = filterResults;
    });
    if (CAMPI != null) {
      providers = providers.filter(it => it.name.includes('CAMPI'));
    }
    if (name != null && name.trim() !== '') {
      providers = providers.filter(it => it.name.includes(name.toUpperCase()));
    }
    // FILTRAR POR ESPECIALIDAD
    if (specialty != null && specialty.trim() !== '' ) {
      console.log("specialty: ", specialty);
      console.log()
      let filterSpecialties:any = [];
      providers = providers.filter((it:any) => {
        console.log("it specialty: ",JSON.stringify(it.specialty));
        it.specialty.map((spec:any) => {
          if (spec.strDescription == specialty) {
            filterSpecialties.push(it);
          }
        });
        it.SubSpecialty.map((sbspec:any) => {
          if (sbspec.strDescription == specialty) {
            filterSpecialties.push(it);
          }
        })
      });
      providers = filterSpecialties;
      console.log("filters: ", filterSpecialties);
      console.log("data location 1234: ", providers);
    }
    console.log('getProvidersByType', name);
    console.log('getProvidersByType', providers);
    const q2 = [];
    providers.forEach(it => {
      q2.push(it._id);
    });
    
    const qdf = 'query($id:[Long]){' +
        'locationOrms(query:{idProvider:{_id_in:' + '$' + 'id}})' +
        '{code priority name latitude longitude fullAddress idProvider { _id code specialty { strDescription } SubSpecialty { strDescription } name priority }}}';
    const querys = {
      query: qdf,
      variables: {
        id: q2
      }
    };
    this.apiService.postMethodMongo(querys).then((res: any) => {
      console.log('getProvidersByType ' , res.data);
      const data = res.data;
      if (department != null) {
        if ( department.trim() !== '' && city.trim() !== '') {
        } else {
        }
      }
      this.getPosition().then((pos: any) => {
        data.locationOrms.forEach(loca => {
          // tslint:disable-next-line:max-line-length
          loca.distance = this.calculationByDistance(JSON.parse(pos.lat), JSON.parse(loca.latitude), JSON.parse(pos.lng), JSON.parse(loca.longitude));
        });
        data.locationOrms = data.locationOrms.sort((n1, n2) => n1.distance - n2.distance);
      });
      this._providersByTypeQuery.next(data);
      this.session.saveParam('datasearch', JSON.stringify(data));
    }).catch(err => {
      console.log(err);
    });
  }

  async getProvidersByType(country: string, type: any[], CAMPI?: boolean, department?: string, city?: string, specialty?: string, name?: string) {
    let q = '';
    let sq = country + '-';
    //let providers = JSON.parse(<string>this.session.getParam('providers')).filter((it:any) => it.code.toString().includes(sq));
    let providers: any[] = [];
    let filterResults: any [] = [];
    JSON.parse(<string>this.session.getParam('providers')).map((it:any) => {
      type.map ((ty:any) => {
        sq = country + '-' + ty + '-';
        if (it.code.toString().includes(sq)) {
          filterResults.push(it);
        }
      })
      providers = filterResults;
    });
    if (CAMPI != null) {
      providers = providers.filter(it => it.name.includes('CAMPI'));
    }
    
    if (name != null && name.trim() !== '') {
      providers = providers.filter((it:any) => it.name.includes(name.toUpperCase()));
    }
    // FILTRAR POR ESPECIALIDAD
    if (specialty != null && specialty.trim() !== '' ) {
      //data.locationOrms = data.locationOrms.filter(it => it.idProvider.indexOf(specialty) !== -1);
      let filterSpecialties:any = [];
      providers = providers.filter((it:any) => {
        it.specialty.map((spec:any) => {
          if (spec.strDescription == specialty) {
            filterSpecialties.push(it);
          }
        });
        it.SubSpecialty.map((sbspec:any) => {
          if (sbspec.strDescription == specialty) {
            filterSpecialties.push(it);
          }
        })
      });
      providers = filterSpecialties;
    }
    const q2:any[] = [];
    providers.forEach((it:any) => {
      q2.push(it._id);
    });

    // IMPLEMENTACION CHUNKED
    var perChunk = 50 // items per chunk  FARMACIAS = 1, HOSPITALES Y MEDICOS = 50,   
    var inputArray = q2;
    var result = inputArray.reduce((resultArray, item, index) => { 
      const chunkIndex = Math.floor(index/perChunk)
      if(!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = [] // start a new chunk
      }
      resultArray[chunkIndex].push(item)
      return resultArray
    }, []);
    console.log("result chunked: ", result);
    // IMPLEMENTACION CHUNKED

    const qdf = 'query($id:[Long]){' +
        'locationOrms(query:{idProvider:{_id_in:' + '$' + 'id}})' +
        '{code priority name latitude longitude fullAddress idProvider { _id code specialty { strDescription } SubSpecialty { strDescription } name priority }}}';

    let resultArrayProviders:any[] = [];

    result.map(async (chunked:any) => {
      const querys = {
        query: qdf,
        variables: {
          id: chunked
        }
      };
      await this.apiService.postMethodMongo(querys).then((res: any) => {
        const data = res.data;
        resultArrayProviders.push.apply(resultArrayProviders, data.locationOrms);
      }).catch(err => {
        //reject(err);
      });
    })
    console.log("resultArrayProviders: ", resultArrayProviders);
    const data = {
      locationOrms: resultArrayProviders
    }

    return new Promise((resolve, reject) => {
      this.getPosition().then((pos: any) => {
        data.locationOrms.forEach((loca:any) => {
          // tslint:disable-next-line:max-line-length
          loca.distance = this.calculationByDistance(JSON.parse(pos.lat), JSON.parse(loca.latitude), JSON.parse(pos.lng), JSON.parse(loca.longitude));
        });
        data.locationOrms = data.locationOrms.sort((n1:any, n2:any) => n1.distance - n2.distance);
        this._providersByTypeQuery.next(data);
        this.session.saveParam('datasearch', JSON.stringify(data));
        resolve(data);
      }).catch(err => {
        reject(err);
      });
    });
  }

  async getProviderInfo(provider: any) {
    const qdf = 'query($id:String){' +
        'contactOrms(query:{idLocation:{code:' + '$' + 'id}})' +
        '{idTypeContact{icon strDescription} code strDescription idLocation {_id code}}' +
        'scheduleOrms(query:{idLocation:{code:' + '$' + 'id}})' +
        '{code strDescription idLocation {_id code}}}';
    const querys = {
      query: qdf,
      variables: {
        id: provider.code
      }
    };
    this.apiService.postMethodMongo(querys).then((res: any) => {
      console.log('getProvidersInfo ' , res.data);
      this._providersInfo.next(res.data);
    }).catch(err => {
      console.log(err);
    });
  }


  async getImportantPhones(id: any) {
    let partition:string = "RPN";
    const qdf = 'query($id:Int){' +
        'importantPhones(query:{country:'+'$'+'id , _partition:\"'+partition+'\"})' +
        '{action active broker country desc icon order phone title}}';
    const querys = {
      query: qdf,
      variables: {
        id
      }
    };
    this.apiService.postMethodMongoSettings(querys).then((res: any) => {
      console.log('getImportantPhones ' , res.data);
      this._importantPhones.next(res.data);
    }).catch(err => {
      console.log(err);
    });
  }

  async getEmergencyPhones(id: any) {
    let partition:string = "RPN";
    const qdf = 'query($id:Int){' +
        'emergencyPhones(query:{country:'+'$'+'id , _partition:\"'+partition+'\"})' +
        '{_partition action active broker country desc icon order phone title}}';
    const querys = {
      query: qdf,
      variables: {
        id
      }
    };
    this.apiService.postMethodMongoSettings(querys).then((res: any) => {
      console.log('getEmergencyPhones ' , res.data);
      this._emergencyPhones.next(res.data);
    }).catch(err => {
      console.log(err);
    });
  }

  async getContact() {
    
    let part:string = 'RPN';
    let user:any = await JSON.parse(this.session.getParam('user'));
    console.log("USER: "+ user);
    //let contactCode:string = JSON.stringify(JSON.parse(user).contactCode);
    let contactCode = user.contactCode;
    console.log("CONTACT CODE: "+ contactCode);
    return new Promise((resolve, reject) => {
      const qdf = 'query($id:String, $part:String){' +
      'contactAppOrmProds(query:{contactID:$id,_partition:$part})' +
      '{active appName broker contactID emailOne emailTwo observation order pbxOne pbxTwo typeLocal web}}';
      
      const querys = {
        query: qdf,
        variables: {
          id: contactCode,
          part
        }
      };
      this.apiService.postMethodMongo(querys).then((res: any) => {
        console.log('contacts::::' + JSON.stringify(res));
        //console.log('getContact ' , res.data);
        this._contactListQuery.next(res.data.contactAppOrmProds);
        resolve(res.data.contactAppOrmProds);
      }).catch(err => {
        console.log(err);
      });
    });

    
  }


  async loadProfileImage(nameFileSource: string, blob: string) {
      const card = await this.session.getvvalueSession('data', 'completeCard');
      const ccode = await this.session.getvvalueSession('data', 'countryCode');
      const path = 'v1/loadProfileImage';
      const url = this.env.urlEnvironment+'/insured-access-web/api';
      let portal:string = "RPN";
      let user:string = "webrpn";
      let tags:string = "";
      const params: any = {};

      params['portal'] = portal;
      params['country'] = ccode;
      params['user'] = user;
      params['tags'] = tags;
      params['policyHolderCardNumber'] = card;
      params['nameFileSource'] = nameFileSource;
      params['blob'] = blob;
      //console.log( params);
      
      //console.log('llamada post');
      this.apiService.postMethodLoadImageProfile(url, path, [], params);
  }

  async getProfileImage() {
    const card = await this.session.getvvalueSession('data', 'completeCard');
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    let path = "v1/getProfileImage"
    let url = this.env.urlEnvironment+"/insured-access-web/api";
    const params = new HttpParams()
          .set("countryCode", ccode)
          .set("portalAllow", 'RPN')
          .set("policyCardNumber", card);
      //console.log("params ",params);
      this.apiService.getMethodImageProfile(url, path, [], params);
      
  }


  async getProvidersBySpecial(country: string, specialty: string) {
    this.getProvidersByType(country, ['1'], null, null, null, specialty, null);
  }
  async quequeQuery(idProvider: string) {
    /*
    const q = 'idProvider == ' + idProvider;
    this.client.subscribe({
      query: gql`
      subscription prov($val:String){
        providerOrms(query:$val){
         idProvider
         name
         queque
         offline
       }
       }
    `,
      variables: { val: q}
    }).subscribe((datas: any) => {
      this._quequeProvider.next(datas.data.providerOrms);
    });
    */
  }

  querySearch(query: string) {
    /*
    const q = 'name contains \'' + query + '\' && specialty.strDescription != null && SubSpecialty.strDescription != null';
    console.log('QUERY' , q);
    const qry = gql`
       query prov($val:String){
        providerOrms(query:$val, take: 30){
         idProvider
         priority
         name
         specialty{strDescription}
         SubSpecialty{strDescription}
       }
      }
      `;
    this.client.watchQuery({
      query: qry,
      variables: {
        val: q,
      },
    })
      .subscribe((result: any) => {
        console.log('++++++++ RESULTS 2 +++++++++', result);
        this._searchQuery.next(result.data.providerOrms);
      });
      */
  }

  async getSpecialtyList() {
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    const providers = JSON.parse(await this.session.getParam('providers'));
    const special = [];
    const filterProviders = providers.filter((p) => JSON.stringify(p.code).toString().indexOf((ccode + '-' + 1 + '-')) > -1 );
    await filterProviders.forEach( it => {
      if (it.specialty.length > 0) {
        it.specialty.forEach(sp => {
          const q = sp.strDescription;
          if (!special.find(it2 => it2.strDescription === q)) {
            special.push(sp);
          }
        });
      }
      /*if (it.SubSpecialty.length > 0) {
        it.SubSpecialty.forEach(sp => {
          const q = sp.strDescription;
          if (!special.find(it2 => it2.strDescription === q)) {
            special.push(sp);
          }
        });
      }*/
      // if(special.find(it2 => it2.))
    });
    special.sort( (a, b) => {
      return a.strDescription.localeCompare(b.strDescription);
    });
    console.log("size specialty: "+ special.length);
    return new Promise((resolve, reject) => {
      //this._specialtyListQuery.next(special);
      resolve(special);
    });
  }

  async getSubSpecialtyList() {
    const ccode = await this.session.getvvalueSession('data', 'countryCode');
    const providers = JSON.parse(await this.session.getParam('providers'));
    const subspecial = [];
    const filterProviders = providers.filter((p) => JSON.stringify(p.code).toString().indexOf((ccode + '-' + 1 + '-')) > -1 );
    await filterProviders.forEach( (it:any) => {
      if (it.SubSpecialty.length > 0) {
        console.log("tiene subespecialidad");
        it.SubSpecialty.forEach((sp:any) => {
          const q = sp.strDescription;
          if (!subspecial.find(it2 => it2.strDescription === q)) {
            subspecial.push(sp);
          }
        });
      }
    });
    subspecial.sort( (a, b) => {
      return a.strDescription.localeCompare(b.strDescription);
    });
    console.log("size subspecialty: "+ subspecial.length);
    return new Promise((resolve, reject) => {
      //this._specialtyListQuery.next(special);
      resolve(subspecial);
    });
  }
  parseSpecialProv(objeto: [], country: string) {
  }

  compressImageWithWorker( q: any) {
    const worker = new Worker('../../app.worker', { type: 'module' });
    worker.onmessage = ({ data }) => {
      console.log('RESPONSE WORKER:::: ', data);
      // this._specialtyListQuery.next(data);
    };
    worker.postMessage({ data: q });
  }

  async getAllinfoProvider(country: string, idProvider: string) {
    /*
    const q = 'idProvider.idProvider ==' + idProvider + ' && idCountry.idCountry == ' + country;
    console.log(q);
    const qry = gql`
    query info($val:String){
       locationOrms(query:$val){
            idLocation
            name
            latitude
            longitude
            fullAddress
              idProvider{
               idProvider
                name
                code
              }
            idService{
              strDescription
              icon
            }
       }
      }
      `;
    this.client.query({
      query: qry,
      variables: {
        val: q,
      },
    }).then((result: any) => {
        this._allInfoProvider.next(result.data.contactOrms);
      });
      */
  }
  myBrowser() {

    if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) !== -1 ) {

      return 'Opera';

    } else if (navigator.userAgent.indexOf('Chrome') !== -1 ) {

      return 'Chrome';

    } else if (navigator.userAgent.indexOf('Safari') !== -1) {

      return 'Safari';

    } else if (navigator.userAgent.indexOf('Firefox') !== -1 ) {

      return 'Firefox';

    } else if ((navigator.userAgent.indexOf('MSIE') !== -1 ) ) {

      return 'IE';

    } else {

      return 'unknown';

    }

  }



  getBrowserVersionOld() {
    // tslint:disable-next-line:prefer-const one-variable-per-declaration
    let userAgent = navigator.userAgent, tem,
      matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(matchTest[1])) {

      tem =  /\brv[ :]+(\d+)/g.exec(userAgent) || [];

      return 'IE ' + (tem[1] || '');

    }

    if (matchTest[1] === 'Chrome') {

      tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);

      if (tem != null) { return tem.slice(1).join(' ').replace('OPR', 'Opera'); }

    }

    matchTest = matchTest[2] ? [matchTest[1], matchTest[2]] : [navigator.appName, navigator.appVersion, '-?'];

    // tslint:disable-next-line:no-conditional-assignment
    if ((tem = userAgent.match(/version\/(\d+)/i)) != null) { matchTest.splice(1, 1, tem[1]); }

    return matchTest.join(' ');

  }

  getBrowserVersion() {
    // tslint:disable-next-line:prefer-const one-variable-per-declaration
    let userAgent = navigator.userAgent, tem,
      matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(matchTest[1])) {

      tem =  /\brv[ :]+(\d+)/g.exec(userAgent) || [];

      return 'IE ' + (tem[1] || '');

    }

    if (matchTest[1] === 'Chrome') {

      tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);

      if (tem != null) { return tem.slice(1).join(' ').replace('OPR', 'Opera'); }

    }

    matchTest = matchTest[2] ? [matchTest[1], matchTest[2]] : [navigator.appName, navigator.appVersion, '-?'];

    // tslint:disable-next-line:no-conditional-assignment
    if ((tem = userAgent.match(/version\/(\d+)/i)) != null) { matchTest.splice(1, 1, tem[1]); }

    return {
      name: matchTest[0],
      version: matchTest[1]
    };

  }
  getIP() {
    this.ip.getIPAddress();
    /**/
  }
  getFcm() {
  }

  isLoggedIn(isLogin: boolean, isRegister: boolean, isOtp: boolean) {
    const q: boolean = isLogin && isRegister && isOtp;
    this.session.saveParam('logged', q.toString());
  }

  async isLogged() {
   return this.session.getParam('logged');
  }
  updateScreenProviders(value: number) {
    this._currentScreen.next(value);
  }
  updateLocationProviders(value: any) {
    this._locationProvider.next(value);
  }
  calculationByDistance(lat1: number, lat2: number, lon1: number, lon2: number) {
    const radius = 6371;
    const dLat = lat2 - lat1;
    const dlon = lon2 - lon1;
    const a = Math.sin(this.degreesToRadians(dLat) / 2) *
      Math.sin(this.degreesToRadians(dLat)) +
      Math.cos(this.degreesToRadians(lat1)) *
      Math.cos(this.degreesToRadians(lat2)) *
      Math.sin(this.degreesToRadians(dlon) / 2) *
      Math.sin(this.degreesToRadians(dlon) / 2);
    const c = 2 * Math.asin(Math.sqrt(a));
    return Math.round(radius * c);
  }
  degreesToRadians(n: number) {
    return n * Math.PI / 180;
  }
  async getPosition(): Promise<any> {
   /* const location: any = [].push({lat: 0.0, lng: 0.0});
    await navigator.geolocation.getCurrentPosition(resp => {
      location.lat = resp.coords.latitude;
      location.lng = resp.coords.longitude;
      console.log('LOCATION', resp.coords);
    });
    return location;*/
    return new Promise((resolve, reject) => {
      const location: any = {lat: 0.0, lng: 0.0};
      navigator.geolocation.getCurrentPosition(resp => {
          location.lat = resp.coords.latitude;
          location.lng = resp.coords.longitude;
          console.log('LOCATION', location);
          resolve(location);
        },
        err => {
          reject(err);
        });
    });

  }
}
